import { axiosConfig } from "../../../../../lib/AxiosConfig";

export const getAllInspectorCompanies = () => {
    return new Promise(async function (resolve, reject) {
        try{
            let allInspectors = axiosConfig.get("/inspectorcompany/getallinspectioncompanies");
            
            console.log(allInspectors);
            resolve(allInspectors);
            return allInspectors;
        }catch(e){
            console.log(e);
            reject(Error("It broke"));
        }
    });
};

export const postNewInspectorHQCompany = (inspectortoPost) =>{
    return new Promise(async function (resolve, reject) {
        try{
            let newBuilderResp = axiosConfig.post("/inspectorcompany/postNewInspectorCompany",inspectortoPost);
            console.log(newBuilderResp);
            resolve(newBuilderResp);
            return newBuilderResp;
        }catch(e){
            console.log(e);
            reject(Error("It broke"));
        }
    });
}


export const patchInspectorHQCompany = (inspectorcompanyToPatch) => {
    return new Promise (async function (resolve,reject){
        try{
            let patchedInspectorResponse = axiosConfig.patch("/inspectorcompany/updateinspectioncompany",inspectorcompanyToPatch);
            resolve(patchedInspectorResponse)

        }catch(e){
            console.log(e);
            reject(Error("it broke"))
        }
    })
}




/**
 * BRANCHES
 */

export const postNewInspectorBranch = (inspectorBranchToPost) => {
    return new Promise (async function (resolve,reject){
        try{
            let postedInspectorBranchResponse = axiosConfig.post("/inspectorbranch/postNewInspectorBranch",inspectorBranchToPost);
            resolve(postedInspectorBranchResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
};


export const patchInspectorBranch = (inspectorBranchToPatch) =>{
    return new Promise (async function (resolve,reject){
        try{
            let patchedInspectorBranchResponse = axiosConfig.post("/inspectorbranch/updateinspectionbranch",inspectorBranchToPatch);
            resolve(patchedInspectorBranchResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
};


/**
 * EMPLOYEES
 */

export const postNewInspectorBranchEE = (bankBranchEEToPost) => {
    return new Promise (async function (resolve,reject){
        try{
            let postedBankEEResponse = axiosConfig.post("/users/newUser",bankBranchEEToPost);
            resolve(postedBankEEResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
};

export const patchInspectorBranchEE = (bankBranchEEToPatch) =>{
    return new Promise (async function (resolve,reject){
        try{
            let patchedBankBranchEEResponse = axiosConfig.patch("/users/patchupdateUser",bankBranchEEToPatch);
            resolve(patchedBankBranchEEResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
};


